// Entities
export const RouterEntitiesId = {
    employer: 'employerId',
    consumer: 'consumerId',
    clearVerifyStaff: 'clearVerifyStaffId',
    verifier: 'verifierId',
    peo: 'peoId',
    peoPayrollProvider: 'peoPayrollProviderId',
    emailChangeRequest: 'emailChangeRequestId',
    passwordChangeRequest: 'passwordChangeRequestId',
    passwordResetRequest: 'passwordResetRequestId',
    invite: 'inviteId',
    inboxItem: 'inboxItemId',
    position: 'positionId',
    integration: 'integrationId',
};
// Root
export const root = '/';
// Auth
export const auth = {
    index: '/auth',
    login: '/auth/login',
    logout: '/auth/logout',
    passwordReset: '/auth/password-reset',
    passwordResetRequeset: `/auth/password-reset-request/:${RouterEntitiesId.passwordResetRequest}`,
    newPassword: '/auth/password-reset/:id',
    signup: `/auth/signup/:${RouterEntitiesId.invite}`,
    verifierSignup: '/auth/signup/verifier',
    signupEmployee: `/auth/employee-signup/:${RouterEntitiesId.employer}`,
    signupEmployeeLegacy: `/auth/consumer-signup/:${RouterEntitiesId.employer}`,
    signupEmployeePeo: `/auth/employee-signup-peo/:${RouterEntitiesId.peo}`,
    signupEmployeePeoLegacy: `/auth/consumer-signup-peo/:${RouterEntitiesId.peo}`,
    signupEmployeePeoPayrollProvider: `/auth/employee-signup-peoPayrollProvider/:${RouterEntitiesId.peoPayrollProvider}`,
    signupEmployeePeoPayrollProviderLegacy: `/auth/consumer-signup-peoPayrollProvider/:${RouterEntitiesId.peoPayrollProvider}`,
    setupMfa: '/auth/setup-mfa',
    setupPaymentMethods: '/auth/setup-payment-methods',
    ssoCallback: '/auth/hrlogics-signin',
};
// Dashboard
export const dashboard = {
    index: '/dashboard',
};
// Inbox
export const inbox = {
    index: '/inbox',
    inboxItem: `/inbox/:${RouterEntitiesId.inboxItem}`,
    inboxTestRequests: '/inbox/test-requests',
    inboxTestRequestItem: `/inbox/test-requests/:${RouterEntitiesId.inboxItem}`,
};
// Verifiers
export const verifiers = {
    index: '/verifiers',
    detail: {
        index: `/verifiers/:${RouterEntitiesId.verifier}`,
        companyInformation: `/verifiers/:${RouterEntitiesId.verifier}/company-information`,
        staff: `/verifiers/:${RouterEntitiesId.verifier}/staff`,
        billingSettings: `/verifiers/:${RouterEntitiesId.verifier}/billing-settings`,
        verificationPurposes: `/verifiers/:${RouterEntitiesId.verifier}/verification-purposes`,
    },
};
// Account
export const account = {
    index: '/account',
    personalInformation: '/account/personal-information',
    security: '/account/security',
    setupMfa: '/account/setup-mfa',
    companyInformation: '/account/company-information',
    employerDisclaimer: '/account/employer-disclaimer',
    settings: '/account/settings',
    generalBillingRules: '/account/general-billing-rules',
    wallet: '/account/wallet',
    billingSettings: '/account/billing-settings',
    billing: '/account/billing',
    privacySettings: '/account/privacy-settings',
    notifications: '/account/notifications',
    verificationPurposes: '/account/verification-purposes',
};
// Employees
export const employees = {
    index: '/employees',
};
// Consumers (legacy route)
export const consumers = {
    index: '/consumers',
};
// My Verify
export const myVerify = {
    index: '/my-verify',
};
// Employers
export const employers = {
    index: '/employers',
    detail: {
        index: `/employers/:${RouterEntitiesId.employer}`,
        wallet: `/employers/:${RouterEntitiesId.employer}/billing`,
        companyInformation: `/employers/:${RouterEntitiesId.employer}/company-information`,
        disclaimers: `/employers/:${RouterEntitiesId.employer}/disclaimers`,
        staff: `/employers/:${RouterEntitiesId.employer}/staff`,
        employees: `/employers/:${RouterEntitiesId.employer}/employees`,
        settings: `/employers/:${RouterEntitiesId.employer}/settings`,
    },
};
// ClearVerify Staff
export const clearVerifyStaff = {
    index: '/clearverify-staff',
};
// Employer Staff
export const employerStaff = {
    index: '/employer-staff',
};
// Peo Payroll Provider Staff
export const peoPayrollProviderStaff = {
    index: '/peo-payroll-provider-staff',
};
// Verifier Staff
export const verifierStaff = {
    index: '/verifier-staff',
};
// Peo Staff
export const peoStaff = {
    index: '/peo-staff',
};
export const emailTracker = {
    index: '/email-tracker',
};
// API & Integrations
export const apiIntegrations = {
    index: '/api-integrations',
    usageLogs: `/api-integrations/:${RouterEntitiesId.integration}/usage-logs`,
};
// PEOs
export const peos = {
    index: '/peos',
    detail: {
        index: `/peos/:${RouterEntitiesId.peo}`,
        companyInformation: `/peos/:${RouterEntitiesId.peo}/company-information`,
        staff: `/peos/:${RouterEntitiesId.peo}/staff`,
        billing: `/peos/:${RouterEntitiesId.peo}/billing`,
        employers: `/peos/:${RouterEntitiesId.peo}/employers`,
        employees: `/peos/:${RouterEntitiesId.peo}/employees`,
        settings: `/peos/:${RouterEntitiesId.peo}/settings`,
        liveStatus: `/peos/:${RouterEntitiesId.peo}/settings/live-status`,
    },
};
export const peoPayrollProviders = {
    index: '/peo-payroll-providers',
    detail: {
        index: `/peo-payroll-providers/:${RouterEntitiesId.peoPayrollProvider}`,
        companyInformation: `/peo-payroll-providers/:${RouterEntitiesId.peoPayrollProvider}/company-information`,
        staff: `/peo-payroll-providers/:${RouterEntitiesId.peoPayrollProvider}/staff`,
        billing: `/peo-payroll-providers/:${RouterEntitiesId.peoPayrollProvider}/billing`,
        peos: `/peo-payroll-providers/:${RouterEntitiesId.peoPayrollProvider}/peos`,
        employers: `/peo-payroll-providers/:${RouterEntitiesId.peoPayrollProvider}/employers`,
        employees: `/peo-payroll-providers/:${RouterEntitiesId.peoPayrollProvider}/employees`,
        settings: `/peo-payroll-providers/:${RouterEntitiesId.peoPayrollProvider}/settings`,
        liveStatus: `/peo-payroll-providers/:${RouterEntitiesId.peoPayrollProvider}/settings/live-status`,
    },
};
// Reports
export const reports = {
    index: '/reports',
    requests: '/reports/requests',
    dataDisputes: '/reports/data-disputes',
    dashboard: '/reports/dashboard',
    verificationRequests: '/reports/verification-requests',
};
// Help Center (Astro site). Prod default; override origin per env via VITE_APP_HELP_CENTER_ORIGIN.
export const DEFAULT_HELP_CENTER_ORIGIN = 'https://help.clearverify.com';
export function helpCenterOrigin(origin = DEFAULT_HELP_CENTER_ORIGIN) {
    return origin.replace(/\/$/, '');
}
export function helpCenterIndex(origin = DEFAULT_HELP_CENTER_ORIGIN) {
    return `${helpCenterOrigin(origin)}/en`;
}
export function helpCenterHub(role, origin = DEFAULT_HELP_CENTER_ORIGIN) {
    return `${helpCenterOrigin(origin)}/en/${role}`;
}
export function helpCenterArticle(role, slug, origin = DEFAULT_HELP_CENTER_ORIGIN) {
    return `${helpCenterOrigin(origin)}/en/${role}/${slug}`;
}
/** @deprecated Prefer helpCenterIndex / helpCenterHub with an explicit origin. */
export const helpCenter = {
    origin: DEFAULT_HELP_CENTER_ORIGIN,
    index: helpCenterIndex(),
    hub: (role) => helpCenterHub(role),
    article: (role, slug) => helpCenterArticle(role, slug),
};
// Resources
export const resources = {
    index: '/resources',
    /** Legacy in-app help entry → external Help Center. */
    helpLegacyIndex: '/resources/help',
    helpLegacy: '/resources/help/*',
    /** Legacy Notion help bookmarks → external Help Center. */
    notionLegacy: '/resources/notion/*',
};
// change-email
export const emailChangeRequest = {
    index: `/email-change-request/:${RouterEntitiesId.emailChangeRequest}`,
};
// change-password
export const passwordChangeRequest = {
    index: `/password-change-request/:${RouterEntitiesId.passwordChangeRequest}`,
};
// my-data
export const myData = {
    index: '/my-data',
};
// Partnerships
export const partnerships = {
    index: '/partnerships',
    detail: {
        index: '/partnerships',
        peo: {
            index: `/partnerships/peo/:${RouterEntitiesId.peo}`,
            companyInformation: `/partnerships/peo/:${RouterEntitiesId.peo}/company-information`,
            staff: `/partnerships/peo/:${RouterEntitiesId.peo}/staff`,
            billing: `/partnerships/peo/:${RouterEntitiesId.peo}/billing`,
            employers: `/partnerships/peo/:${RouterEntitiesId.peo}/employers`,
            employees: `/partnerships/peo/:${RouterEntitiesId.peo}/employees`,
            settings: `/partnerships/peo/:${RouterEntitiesId.peo}/settings`,
            liveStatus: `/partnerships/peo/:${RouterEntitiesId.peo}/settings/live-status`,
        },
        peoPayrollProvider: {
            index: `/partnerships/peo-payroll-provider/:${RouterEntitiesId.peoPayrollProvider}`,
            companyInformation: `/partnerships/peo-payroll-provider/:${RouterEntitiesId.peoPayrollProvider}/company-information`,
            staff: `/partnerships/peo-payroll-provider/:${RouterEntitiesId.peoPayrollProvider}/staff`,
            billing: `/partnerships/peo-payroll-provider/:${RouterEntitiesId.peoPayrollProvider}/billing`,
            peos: `/partnerships/peo-payroll-provider/:${RouterEntitiesId.peoPayrollProvider}/peos`,
            employers: `/partnerships/peo-payroll-provider/:${RouterEntitiesId.peoPayrollProvider}/employers`,
            employees: `/partnerships/peo-payroll-provider/:${RouterEntitiesId.peoPayrollProvider}/employees`,
            settings: `/partnerships/peo-payroll-provider/:${RouterEntitiesId.peoPayrollProvider}/settings`,
            liveStatus: `/partnerships/peo-payroll-provider/:${RouterEntitiesId.peoPayrollProvider}/settings/live-status`,
        },
    },
};
// persik
export const persik = {
    index: '/persik',
};
// maintenance
export const maintenance = {
    index: '/maintenance',
};
// appRoutes
export const appRoutes = {
    root,
    auth,
    dashboard,
    inbox,
    verifiers,
    account,
    myVerify,
    employers,
    clearVerifyStaff,
    employerStaff,
    peoPayrollProviderStaff,
    verifierStaff,
    peoStaff,
    emailTracker,
    apiIntegrations,
    employees,
    peos,
    peoPayrollProviders,
    reports,
    resources,
    emailChangeRequest,
    passwordChangeRequest,
    myData,
    partnerships,
    persik,
    maintenance,
    consumers,
};
//# sourceMappingURL=routes.js.map